module.exports = __webpack_public_path__ + "media/images/home/ayo-ke-bpr-c609089dc780eb6dca4fd17be3a4264c.png";